// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");
let PaginationBoxRefetchable = require("../../common/pagination/PaginationBoxRefetchable.bs.js");
let ClientNeedsPageRelayQueryParams = require("./ClientNeedsPageRelayQueryParams.bs.js");

function ClientNeedsPageRelaySharedComponents$PaginationBox(props) {
  let params = props.params;
  let nextCursor = props.nextCursor;
  let prevCursor = props.prevCursor;
  let refetch = props.refetch;
  let tmp;
  if (prevCursor !== undefined) {
    let newrecord = {...params};
    tmp = ClientNeedsPageRelayQueryParams.paramsToUrl((newrecord.after = prevCursor, newrecord));
  } else {
    tmp = undefined;
  }
  let tmp$1;
  if (nextCursor !== undefined) {
    let newrecord$1 = {...params};
    tmp$1 = ClientNeedsPageRelayQueryParams.paramsToUrl((newrecord$1.after = nextCursor, newrecord$1));
  } else {
    tmp$1 = undefined;
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(PaginationBoxRefetchable.make, {
      previousPagePath: tmp,
      onClickPrevious: () => refetch("push", undefined, prevCursor, params => params),
      nextPagePath: tmp$1,
      onClickNext: () => refetch("push", nextCursor, undefined, params => params)
    }),
    className: "col-span-1 md:col-span-2 lg:col-span-3 flex justify-center items-center"
  });
}

let PaginationBox = {
  make: ClientNeedsPageRelaySharedComponents$PaginationBox
};

let QueryParams;

exports.QueryParams = QueryParams;
exports.PaginationBox = PaginationBox;
/* react/jsx-runtime Not a pure module */
